import { render, staticRenderFns } from "./WipWarehousing.vue?vue&type=template&id=363bc076&scoped=true"
import script from "./WipWarehousing.vue?vue&type=script&lang=ts"
export * from "./WipWarehousing.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363bc076",
  null
  
)

export default component.exports